module.exports = __webpack_public_path__ + "static/flags/ES-58a9e30f783e86fd5397a6105b8fd281.gif";